import React from "react";

const Divider = ({ w }) => {
    return (
        <div className="flex w-full justify-center px-4 sm:px-6 box-border">
            <hr
                className="my-2 h-0 max-w-full shrink-0 border-0 border-t border-dashed border-gray-200 bg-transparent"
                style={{ width: w != null ? `${w}%` : "100%" }}
            />
        </div>
    );
};

export default Divider;
